<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="4"
                          label="Fee Schedule"
                          :state="stateForField('selectedFeeScheduleId')"
                          :invalid-feedback="errorForField('selectedFeeScheduleId')"
                          label-class="text-right">
              <b-dropdown menu-class="dropdown-container" :text="feeScheduleName"
                          :variant="hasError('selectedFeeScheduleId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="feeSchedule in feeSchedules" :key="feeSchedule.feeScheduleId"
                                 @click.prevent="setFeeSchedule(feeSchedule)">{{ feeSchedule.name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Update Estimate
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '../mixins/ErrorsMixin.js'
  import api from '@/services/api'

  export default {
    name: 'EstimateFeeScheduleModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      currentFeeScheduleId: {
        type: Number,
        default: 0
      },

      title: {
        type: String,
        default: 'Change Fee Schedule'
      },

      ascFeeSchedule: {
        type: Boolean,
        default: false
      },

      isAsc: {
        type: Boolean,
        default: false
      },

      ascLocationId: {
        type: Number,
        default: 0
      }
    },

    data () {
      return {
        selectedFeeScheduleId: 0,
        isSaving: false,
        orgFeeSchedules: [],
        ascFeeSchedules: []
      }
    },

    watch: {
      visible (newValue, oldValue) {
        if (newValue) {
          this.clearData()
        }
      },

      ascLocationId (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue) {
            this.loadAscFeeSchedules()
          } else {
            this.ascFeeSchedules = []
          }
        }
      },

      ascFeeSchedule (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue) {
            this.loadAscFeeSchedules()
          } else {
            this.loadFeeSchedules()
          }
        }
      }
    },

    computed: {
      feeScheduleName () {
        if (this.selectedFeeScheduleId) {
          const currentFeeSchedule = this.feeSchedules.filter(aFeeSchedule => {
            return aFeeSchedule.feeScheduleId === this.selectedFeeScheduleId
          }).shift()

          if (currentFeeSchedule) {
            return currentFeeSchedule.name
          }
        }

        return 'Click to Select'
      },

      feeSchedules () {
        if (this.ascFeeSchedule === false) {
          return this.orgFeeSchedules.map((orgFeeSchedule) => {
            return {
              feeScheduleId: orgFeeSchedule.organizationAllowableFeeScheduleId,
              name: orgFeeSchedule.name
            }
          })
        } else {
          return this.ascFeeSchedules.map((ascFeeSchedule) => {
            return {
              feeScheduleId: ascFeeSchedule.organizationAscFeeScheduleId,
              name: ascFeeSchedule.name
            }
          })
        }
      }
    },

    methods: {
      clearData () {
        this.clearAllErrors()
        this.selectedFeeScheduleId = this.currentFeeScheduleId
      },

      validate () {
        this.clearAllErrors()

        if (!this.selectedFeeScheduleId > 0) {
          this.addErrorForField('selectedFeeScheduleId', 'You must select a fee schedule')
        }

        return !this.hasErrors()
      },

      loadFeeSchedules () {
        api.get('/Dashboard/Organization/FeeSchedules').then(response => {

          this.orgFeeSchedules = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load fee schedules: ' + error.message, error)
          }
        })
      },

      loadAscFeeSchedules () {
        if (!this.isAsc) {
          return
        }

        api.get('/Dashboard/Organization/AscFeeSchedules/' + this.ascLocationId).then(response => {

          this.ascFeeSchedules = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load asc fee schedules: ' + error.message, error)
          }
        })
      },

      setFeeSchedule (feeSchedule) {
        this.selectedFeeScheduleId = feeSchedule.feeScheduleId
      },

      save () {
        if (!this.validate()) {
          return
        }

        this.$emit('feeScheduleUpdated', this.selectedFeeScheduleId)
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    },

    created () {
      if (this.ascFeeSchedule) {
        this.loadAscFeeSchedules()
      } else {
        this.loadFeeSchedules()
      }
    }
  }
</script>

<style scoped>

</style>
